import { useMemo } from "react";
import Box from "@mui/material/Box";
import { styles } from "./image_section";
import ImageCard from "../../components/ImageCard.jsx";
import { useI18n } from "@/i18n/I18nProvider";
import Title from "../../components/mini-components/Title.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setOptionId } from "../../Redux/store";

export default function ImageSection({
  productsCategory,
  productsList,
  title,
  titleVarient,
}) {
  const dispatch = useDispatch();
  const optionId = useSelector((state) => state.option.id);
  const { t, locale } = useI18n();
  const categories = useMemo(() => {
    return productsCategory || [];
  }, [productsCategory]);

  const products = useMemo(() => {
    return productsList || [];
  }, [productsList]);

  const selectedOptionId = optionId ?? categories?.[0]?.id;

  const gridOptions =
    selectedOptionId == null
      ? {
          xs: "auto auto",
          sm: "repeat(auto-fill, 224px)",
        }
      : {
          xs: "auto auto",
          sm: "repeat(auto-fill, 300px)",
        };

  const filteredProducts = useMemo(() => {
    if (selectedOptionId == null) return products;

    return products.filter((product) => product.type === selectedOptionId);
  }, [products, selectedOptionId]);
  return (
    <Box
      id="all-products"
      sx={styles.container}
      className="horizontal-safe-padding vertical-safe-padding"
    >
      <Title h2={titleVarient} title={title} />

      <Box sx={styles.btnContainer}>
        {categories.map((item) => (
          <Box
            key={item.id}
            component="button"
            sx={item.id === selectedOptionId ? styles.btnActive : styles.btn}
            onClick={() => dispatch(setOptionId(item.id))}
          >
            <Box
              component={title ? "h2" : "h3"}
              sx={
                item.id === selectedOptionId ? styles.btnActiveH3 : styles.btnH3
              }
            >
              {item.name?.[locale] || item.name?.en || ""}
            </Box>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          ...styles.grid,
          gridTemplateColumns: gridOptions,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: {
            xs: "center",
            sm: "start",
          },
        }}
      >
        {filteredProducts.map((item) => (
          <ImageCard
            title={title}
            key={item.id}
            title1=""
            title2={item.title?.text?.[locale] || item.title?.text?.en || ""}
            img={item[`img_${locale}`] || item.img_en || ""}
            url={item.url}
            alt={item[`alt_${locale}`] || item.alt_en || ""}
            bgcolor="#fff"
            optionId={item.type}
          />
        ))}
      </Box>
    </Box>
  );
}
